const state = {
    msalConfig: {
        auth: {
            clientId: process.env.VUE_APP_MS_CLIENT_ID,
            authority: process.env.VUE_APP_MS_AUTHORITY,
        },
        cache: {
            cacheLocation: 'localStorage',
        },
    },
    accessToken: ''
};

const getters = {
    getMsalConfig: (state) => state.msalConfig,
};

const mutations = {
    setAccessToken(state, token) {
        state.accessToken = token;
    }
};

const actions = {
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};